export const fadeInBlur = {
  initial: {
    translateY: 6,
    opacity: 0,
    filter: 'blur(10px)',
  },
  animate: { translateY: 0, opacity: 1, filter: 'blur(0px)' },
  transition: {
    duration: 0.7,
    ease: 'easeInOut',
  },
}
